// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"490":"0267a662","533":"041597e1","798":"640b2211"}[chunkId] + ".chunk.css";
};